module.exports = __webpack_public_path__ + "img/item2_first.6e254d5b.png";